module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074b3_banner_800x600.81a47039.png";